// extracted by mini-css-extract-plugin
export default {"section":"Section_section__EnkBR","timeline":"Section_timeline__p0nHj"};